function substituirTodosTitulosProdList() {
  const etapa = document.getElementById("HdEtapaLoja")?.value;

  if (etapa == "PRODUTO") return;

  const titulos = document.querySelectorAll(".prod-list-titles-title");

  titulos.forEach((titulo) => {
    titulo.outerHTML = `
      <span class="custom-title-prodlist">
        Confira nossas 
        <span class="custom-subtitle-prodlist">melhores ofertas</span>
      </span>
    `;
  });
}

// try {
//   isReady("categorias", substituirTodosTitulosProdList);
// } catch (error) {}

function tagDescontoPix() {
  const listHomeProds = wsMain?.globalData?.listHomeProds?.produtos;
  const listGroupProds = wsMain?.globalData?.listGroupProds?.grupos;
  const relatedProds = wsMain?.globalData?.listRelatedProds;
  const lastProds = wsMain?.globalData?.listLastProds;
  const listCategoryProds = wsMain?.globalData?.listCategoryProds?.produtos;
  const infoProduct = wsMain?.globalData?.infoProduto;
  const allProducts = [];

  if (infoProduct) {
    allProducts.push(infoProduct);
  }

  if (relatedProds && relatedProds.length > 0) {
    allProducts.push(...relatedProds);
  }

  if (lastProds && lastProds.length > 0) {
    allProducts.push(...lastProds);
  }

  if (listHomeProds && listHomeProds.length > 0) {
    listHomeProds.forEach((prod) => {
      allProducts.push(prod);
    });
  }

  if (listGroupProds && listGroupProds.length > 0) {
    listGroupProds.forEach((group) => {
      if (group.produtos && group.produtos.length > 0) {
        group.produtos.forEach((prod) => {
          allProducts.push(prod);
        });
      }
    });
  }

  if (listCategoryProds && listCategoryProds.length > 0) {
    listCategoryProds.forEach((prod) => {
      allProducts.push(prod);
    });
  }
  console.log(allProducts);
  if (!allProducts || allProducts.length === 0) {
    return;
  }

  if (infoProduct) {
    if (!infoProduct.precos?.desconto_avista) return;
    const tagDescontoPix = document.querySelector(".row .tagDescontoPix");

    if (tagDescontoPix.classList.contains("tagDescontoPixAlreadyApplied"))
      return;

    if (tagDescontoPix) {
      tagDescontoPix.classList.add("tagDescontoPixAlreadyApplied");
      tagDescontoPix.innerHTML = `- ${infoProduct.precos.desconto_avista}% no PIX`;
    }
  }

  allProducts.forEach((prod) => {
    if (!prod.precos?.desconto_avista) return;
    const prodsElements = document.querySelectorAll(
      `[ws-prod-sku="${prod.codigo}"]`,
    );
    prodsElements.forEach((prodElement) => {
      const tagDescontoPix = prodElement.querySelector(".tagDescontoPix");
      if (!tagDescontoPix) return;
      if (tagDescontoPix.classList.contains("tagDescontoPixAlreadyApplied"))
        return;

      tagDescontoPix.classList.add("tagDescontoPixAlreadyApplied");
      tagDescontoPix.innerHTML = `-${prod.precos.desconto_avista}% no PIX`;
    });
  });
}
try {
  isReady("product-list", tagDescontoPix);
  const listagem = document.querySelector(`#BodyListagem`);

  if (listagem) {
    window.addEventListener("scroll", () => {
      tagDescontoPix();
    });
  }
} catch (error) { }

try {
  isReady("pag-produto", tagDescontoPix);
} catch (error) { }

function adicionarLinkWebstore() {
  const logo = document.querySelector(".logoWebstoreCustom");

  if (!logo) return;

  // Pega o domínio atual da loja
  const dominio = window.location.hostname;

  // Monta a URL final
  const url = `https://www.webstore.com.br/?utm_source=footer&utm_medium=ecommerce&utm_campaign=customer&utm_term=${dominio}`;

  // Deixa clicável
  logo.style.cursor = "pointer";

  logo.addEventListener("click", () => {
    window.open(url, "_blank");
  });
}

try {
  isReady("categorias", adicionarLinkWebstore);
} catch (error) { }

// window.WS_FRETE_GRATIS_CONFIG, se existir, sobrescreve os valores padrão abaixo:
// { valorMinimo: 250, cidades: [{ cidade: "são paulo", cepInicio: "01000-000", cepFim: "05999-999" }, ...], textoComoFunciona: "Conteúdo em breve." }
// Em cada item de "cidades", informar cepInicio/cepFim restringe por faixa de CEP;
// sem eles, a checagem cai para comparação pelo nome da cidade.
// "textoComoFunciona" é usado pelo popup "Como funciona" (pagina-produto-personalizado.js).
function obterConfigFreteGratis() {
  const config = window.WS_FRETE_GRATIS_CONFIG;

  const valorMinimo =
    Number(config?.valorMinimo) > 0 ? Number(config.valorMinimo) : 250;

  const cidades =
    Array.isArray(config?.cidades) && config.cidades.length
      ? config.cidades
      : [{ cidade: "são paulo" }];

  return { valorMinimo, cidades };
}

function cepParaNumero(cep) {
  const digitos = (cep || "").replace(/\D/g, "");
  return digitos ? Number(digitos.padEnd(8, "0").slice(0, 8)) : null;
}

function localizacaoAtendeFreteGratis(loc, cidades) {
  if (!loc) return false;

  const cidadeCliente = (loc.city || "").trim().toLowerCase();
  const cepCliente = cepParaNumero(loc.zipcode);

  return cidades.some((entrada) => {
    const cepInicio = cepParaNumero(entrada.cepInicio);
    const cepFim = cepParaNumero(entrada.cepFim);

    if (cepCliente != null && cepInicio != null && cepFim != null) {
      return cepCliente >= cepInicio && cepCliente <= cepFim;
    }

    if (entrada.cidade) {
      return cidadeCliente === entrada.cidade.trim().toLowerCase();
    }

    return false;
  });
}

function clienteLocalizadoEmAreaAtendida(cidades) {
  try {
    const raw = localStorage.getItem(CEP_HEADER_STORAGE_KEY);
    if (!raw) return false;
    const loc = JSON.parse(raw);
    return localizacaoAtendeFreteGratis(loc, cidades);
  } catch (e) {
    return false;
  }
}

function adicionarTagFreteGratisNaImagem() {
  if (typeof TAG_FRETE_GRATIS_PERSONALIZADA == 'undefined') return

  const { valorMinimo, cidades } = obterConfigFreteGratis();
  const clienteAtendido = clienteLocalizadoEmAreaAtendida(cidades);

  const produtos = document.querySelectorAll(
    ".prod-showcase-holder",
  );

  produtos.forEach((holder) => {
    const imageBox = holder.querySelector(".prod-showcase-image");
    if (!imageBox) return;

    const tagExistente = imageBox.querySelector(".tag-fretegratis-imagem");

    let preco = holder.querySelector('.pricePix') || holder.querySelector('.prod-showcase-price-sell')

    preco = preco?.textContent

    const valor = Number(
      preco
        ?.split('PIX')[0]
        .replace('R$', '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
    );

    const elegivel = clienteAtendido && valor >= valorMinimo;

    if (!elegivel) {
      if (tagExistente) tagExistente.remove();
      return;
    }

    if (tagExistente) return;

    const novaTag = document.createElement("div");
    novaTag.className = "tag-fretegratis-imagem";
    novaTag.textContent = "Frete Grátis";
    imageBox.appendChild(novaTag);
  });
}

try {
  isReady("product-list", adicionarTagFreteGratisNaImagem);
  const listagemFreteGratis = document.querySelector(`#BodyListagem`);
  if (listagemFreteGratis) {
    window.addEventListener("scroll", () => {
      adicionarTagFreteGratisNaImagem();
    });
  }
} catch (error) { }

try {
  isReady("pag-produto", adicionarTagFreteGratisNaImagem);
} catch (error) { }

try {
  isReady("categorias", adicionarTagFreteGratisNaImagem);
} catch (error) { }

window.addEventListener("wsCustomerLocationUpdated", adicionarTagFreteGratisNaImagem);


function ajustarParcelas() {
  document.querySelectorAll(".prod-showcase-parcela").forEach((parcela) => {
    const preco = parcela.querySelector(".prod-showcase-price-sell")?.textContent.trim();
    const parcelamento = parcela.querySelector(".price-installment-value")?.textContent.trim();

    if (!preco || !parcelamento) return;

    parcela.textContent = `ou ${preco} em ${parcelamento}`;
  });
}

try {
  isReady("categorias", ajustarParcelas);
} catch (error) { }

function esconderPrecoOriginal() {
  const produtos = document.querySelectorAll('.prod-showcase-holder')

  if (!produtos.length) return

  produtos.forEach(prod => {
    try {
      if (prod.classList.contains('unavaliable')) {
        prod.querySelectorAll('.prod-showcase-avista .prod-showcase-price-off, .prod-showcase-avista .pricePix, .prod-showcase-avista .tagDescontoPixFixo').forEach(elemento => {
          elemento.style.display = 'none'
        })

        return
      }

      const original = prod.querySelector('.pricePix')
      const textoPrecoPix = original?.textContent
        ?.replace(/\s+/g, ' ')
        ?.replace('PIX', '')
        ?.trim()

      if (!original || !textoPrecoPix) return

      const precoParaEscconder = prod.querySelector('.price-sell-container')
      if (!precoParaEscconder) return

      precoParaEscconder.style.display = 'none'

    } catch (error) { }
  })
}

try {
  isReady("product-list", esconderPrecoOriginal);
} catch (error) { }

/* ============================
   Alinhamento dos cards de produto
   ============================ */
function alinharCards() {
  /* Só executa em páginas com produtos. Pula também quem estiver dentro de um bloco marcado com
     data-align-cards="false" — dá pra desligar o alinhamento em seções específicas sem tocar
     neste arquivo de novo.
     NÃO usar data-wsjs-options pra essa flag: a âncora [data-wsjs-prod-list] é DESCARTADA e
     substituída pelo conteúdo real assim que o client termina de buscar os produtos
     (wsMain.tools.replaceSpanTag, chamado de wsapi3-prod-list.js) — e essa troca copia os
     atributos da âncora original pro elemento novo só PARCIALMENTE: "data-wsjs-options" (e
     "data-wsjs-prod-list") estão na lista de exclusão de propósito (ver replaceSpanTag em
     wsapi3-main.js), então qualquer coisa lida de lá já não existe mais no DOM quando
     alinharCards() roda (via isReady, sempre depois da troca). Testei e confirmei isso —
     "align-cards: false" no data-wsjs-options simplesmente sumia antes de chegar aqui.
     data-align-cards, por ser um atributo comum (não um dos "data-wsjs-*" do blocklist) no
     <section>/<div> que ENVOLVE a âncora (não na âncora em si), nunca é tocado pela troca —
     sobrevive inteiro. */
  const infos = Array.from(document.querySelectorAll('.prod-showcase-info')).filter(function(info) {
    if (info.closest('.prod-related-container')) return false;
    return !info.closest('[data-align-cards="false"]');
  });

  if (!infos.length) return;

  /* CARD */
  infos.forEach(function(info) {
    info.style.display = 'flex';
    info.style.flexDirection = 'column';
    info.style.height = 'auto';
    info.style.minHeight = '260px';
  });

  /* AVALIAÇÕES */
  infos.forEach(function(info) {
    var reviews = info.querySelector('.ws-review-star-container');
    if (!reviews) {
      reviews = document.createElement('div');
      reviews.className = 'ws-review-star-container';
      info.insertBefore(reviews, info.querySelector('.prod-showcase-info-name'));
    }
    reviews.style.display = 'flex';
    reviews.style.alignItems = 'center';
    reviews.style.minHeight = '24px';
  });

  /* NOME (3 LINHAS) */
  infos.forEach(function(info) {
    var el = info.querySelector('.prod-showcase-info-name');
    if (!el) return;

    el.style.minHeight = '72px';
    el.style.lineHeight = '24px';
    el.style.display = '-webkit-box';
    el.style.webkitBoxOrient = 'vertical';
    el.style.webkitLineClamp = '3';
    el.style.overflow = 'hidden';
  });

  /* PREÇO */
  infos.forEach(function(info) {
    var container = info.querySelector('.prod-showcase-price-container');
    if (!container) return;

    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '2px';
    container.style.minHeight = '82px';

    var precoOff = container.querySelector('.prod-showcase-price-off');
    if (!precoOff) {
      precoOff = document.createElement('span');
      precoOff.className = 'prod-showcase-price-off';
      precoOff.innerHTML = '&nbsp;';
      container.prepend(precoOff);
    }
    precoOff.style.display = 'block';
    precoOff.style.minHeight = '18px';
    precoOff.style.lineHeight = '18px';
    if (precoOff.textContent.trim() === '') {
      precoOff.style.visibility = 'hidden';
    } else {
      precoOff.style.visibility = 'visible';
    }
  });

  /* PARCELAMENTO */
  infos.forEach(function(info) {
    var el = info.querySelector('.prod-showcase-parcela');
    if (!el) return;

    el.style.minHeight = '38px';
  });

  /* BOTÃO */
  infos.forEach(function(info) {
    var btn = info.querySelector('.prod-showcase-info-button');
    if (!btn) return;

    btn.style.display = 'block';
    btn.style.visibility = 'visible';
    btn.style.opacity = '1';
    btn.style.marginTop = '16px';
  });
}

try {
  isReady("product-list", alinharCards);
} catch (error) { }

try {
  isReady("categorias", alinharCards);
} catch (error) { }

/* ============================
   Avaliações condensadas na listagem (1 estrela + nota média)
   ============================
   As 5 estrelas (spans .fill-star/.half-star/.empty-star) + o parágrafo
   ".allreviews" com a contagem são inseridos dentro de .ws-review-star-container
   por um app de avaliações de terceiro (WS Reviews — carregado fora deste
   tema, via app instalado no painel da loja), não por nada daqui. Ele nunca
   grava a nota numérica em lugar nenhum do DOM — só usa as classes acima pra
   colorir cada uma das 5 estrelas (avaliacoes.css já define as cores:
   fill-star = dourado, half-star = meio dourado/cinza, empty-star = cinza).
   Dá pra reconstruir a nota contando quantos ".fill-star" existem + 0.5 se
   tiver um ".half-star" — é a mesma precisão (arredondado em .5) que o
   próprio app usa pra pintar as estrelas.

   Quando o produto não tem avaliação nenhuma (rate 0), o app nem chega a
   mexer nesse container — ele fica vazio pra sempre (por isso
   ".ws-review-star-container:empty{display:none}" em avaliacoes.css). Por
   isso aqui a gente espera um tempo de graça (carregamento assíncrono do
   app) e, se continuar vazio depois disso, desenha a estrela cinza sozinha,
   sem nota — como pedido.

   Roda em polling contínuo (e não só uma vez via isReady) porque o app de
   avaliações popula os containers de forma assíncrona (fetch próprio) e
   porque a listagem pode carregar produtos novos depois (scroll infinito). */
function condensarAvaliacoesListagem() {
  var TEMPO_DE_GRACA_MS = 6000;
  var agora = Date.now();

  document.querySelectorAll(".ws-review-star-container").forEach(function (container) {
    if (container.dataset.wsReviewCondensado === "1") return;

    if (!container.dataset.wsReviewVistoEm) {
      container.dataset.wsReviewVistoEm = String(agora);
    }

    var jaProcessadoPeloApp = container.querySelector(":scope > .fill-star, :scope > .half-star, :scope > .empty-star") !== null;
    var tempoDesdeQueApareceu = agora - Number(container.dataset.wsReviewVistoEm);

    // ainda não foi populado pelo app e ainda não faz tempo suficiente pra
    // considerar "sem avaliação de fato" — espera mais um ciclo (evita
    // cravar cinza um produto que só ainda não carregou a nota).
    if (!jaProcessadoPeloApp && tempoDesdeQueApareceu < TEMPO_DE_GRACA_MS) return;

    var fillCount = container.querySelectorAll(":scope > .fill-star").length;
    var temMeia = container.querySelector(":scope > .half-star") !== null;
    var media = fillCount + (temMeia ? 0.5 : 0);

    var estrela = document.createElement("span");
    estrela.className = media > 0 ? "fill-star" : "empty-star";
    estrela.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.44 33.53">' +
      '<path d="M16.5,.71c.39-.68,1.25-.91,1.92-.53,.22,.12,.4,.31,.53,.53l4.81,8.46c.2,.35,.55,.6,.94,.68l9.61,1.92c.75,.14,1.24,.87,1.1,1.62-.05,.25-.17,.49-.34,.68l-6.64,7.15c-.28,.3-.41,.7-.36,1.1l1.13,9.65c.08,.77-.49,1.46-1.26,1.54-.24,.02-.49-.02-.72-.12l-8.92-4.04c-.37-.17-.8-.17-1.17,0l-8.92,4.05c-.71,.31-1.54,0-1.86-.72-.1-.22-.14-.46-.11-.71l1.13-9.65c.05-.4-.08-.8-.36-1.1L.37,14.08c-.52-.56-.49-1.44,.08-1.96,.19-.18,.43-.29,.68-.34l9.61-1.92c.4-.08,.74-.33,.94-.68L16.5,.71Z"></path>' +
      "</svg>";

    container.innerHTML = "";
    container.appendChild(estrela);

    if (media > 0) {
      var notaArredondada = Math.round(media * 2) / 2;
      var nota = document.createElement("span");
      nota.className = "ws-review-rate-label";
      nota.textContent = notaArredondada % 1 === 0 ? String(notaArredondada) : String(notaArredondada);
      container.appendChild(nota);
    }

    container.classList.add("ws-review-star-single");
    container.dataset.wsReviewCondensado = "1";
  });
}

setInterval(condensarAvaliacoesListagem, 500);


